'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _LoginModal = _interopRequireDefault(require("Modals/LoginModal"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _BlockLastTestimonies = _interopRequireDefault(require("Components/Block/BlockLastTestimonies"));
var _ConstructionIcon = _interopRequireDefault(require("Icons/ConstructionIcon"));
var _RecrutementIcon = _interopRequireDefault(require("Icons/RecrutementIcon"));
var _EntrepreneurIcon = _interopRequireDefault(require("Icons/EntrepreneurIcon"));
var _EtudiantIcon = _interopRequireDefault(require("Icons/EtudiantIcon"));
var _OrientationIcon = _interopRequireDefault(require("Icons/OrientationIcon"));
var _FriseIcon = _interopRequireDefault(require("Icons/FriseIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class InfoCandidatePage extends _react.Component {
  state = {
    login_modal: false
  };
  openLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      login_modal_trigger: e.target,
      login_modal: true
    });
  };
  closeLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login_modal_trigger: undefined,
      login_modal: false
    });
  };
  handleLogin = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'loginModal'
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Candidat | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content u-margin-top-10"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title"
    }, "Construisez votre projet professionnel pour trouver enfin l\u2019emploi qui vous correspond."), /*#__PURE__*/_react.default.createElement("p", null, "B\xE9n\xE9ficiez d\u2019un soutien personnalis\xE9 pour la recherche d\u2019emploi et acc\xE9dez aux offres des employeurs. Ici vous trouverez des professionnels de l\u2019emploi et de l\u2019autisme, qui comprennent vos attentes et vos besoins"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--blue u-margin-top-40",
      href: "/inscription-candidat"
    }, "Inscrivez-vous gratuitement")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-personnesasperger.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Parce que chacun d\u2019entre vous poss\xE8de des aspirations, des exp\xE9riences et ", /*#__PURE__*/_react.default.createElement("br", null), "des talents diff\xE9rents, nous vous proposons diff\xE9rents parcours :"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item c-parcours-grid-item--orange"
    }, /*#__PURE__*/_react.default.createElement(_RecrutementIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Recherche d'emploi")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item c-parcours-grid-item--dark-blue"
    }, /*#__PURE__*/_react.default.createElement(_OrientationIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Orientation ou reconversion \xE0 l\u2019Emploi")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item c-parcours-grid-item--blue"
    }, /*#__PURE__*/_react.default.createElement(_ConstructionIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Construction du projet professionnel")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid-item c-parcours-grid-item--pink"
    }, /*#__PURE__*/_react.default.createElement(_EtudiantIcon.default, {
      className: "c-parcours-grid-item__icon "
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Etudiant ou en formation"))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Comment \xE7a marche ?"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center"
    }, "Que votre projet professionnel soit abouti ou enti\xE8rement \xE0 cr\xE9er,", /*#__PURE__*/_react.default.createElement("br", null), " nous vous accompagnons pour chaque \xE9tape, \xE0 votre rythme"), /*#__PURE__*/_react.default.createElement(_FriseIcon.default, {
      className: "step-frise"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-margin-top-40 u-center u-full-width"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--green",
      href: "/inscription-candidat"
    }, "Inscrivez-vous gratuitement")), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40 u-margin-bottom-0"
    }, "Et \xE7a fonctionne"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-margin-top-0"
    }, "D\xE9couvrez ce qu\u2019en disent les candidats"), /*#__PURE__*/_react.default.createElement(_BlockLastTestimonies.default, {
      type: "Candidat"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--medium"
    }, "Inscrivez-vous ", /*#__PURE__*/_react.default.createElement("br", null), "gratuitement en seulement ", /*#__PURE__*/_react.default.createElement("br", null), "quelques minutes"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn c-btn--blue u-margin-top-40",
      href: "/inscription-candidat"
    }, "Cr\xE9er un compte")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-candidats.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement(_LoginModal.default, {
      onClose: component.closeLoginModal,
      open: state.login_modal,
      trigger_src: state.login_modal_trigger,
      onLogin: component.handleLogin
    })));
    return output;
  }
}
exports.default = InfoCandidatePage;
